import React, { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

import {
  isEmptyCollection,
  SiteConfigManager,
  useCasinoNewState,
  useCategoryGamesState,
} from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';
import { ChipsItem, Label } from '@atlas/ui';

import { BASE_PATH } from 'common/constants';
import { defaultRoutes } from 'components/MainRouter/constants';

import ProvidersBlockSlider from './ProvidersBlockSlider';

const ProvidersFilterBlock = ({ onProviderClick }) => {
  const {
    group,
    providers: { data: providers },
  } = useCasinoNewState();
  const { loading: categoryGamesLoading } = useCategoryGamesState();
  const { push: historyPush } = useHistory();
  const location = useLocation();
  const allProvidersPage = SiteConfigManager.getConfig('config.pages').find(
    page => page.type === COMPONENT_TYPES.All_PROVIDERS,
  );

  const showAllProvidersHandler = useCallback(() => {
    const searchParams = new URLSearchParams();
    if (group) {
      searchParams.set('group', group);
    }
    const searchString = searchParams.toString();
    const path = searchString
      ? `${defaultRoutes.allProvidersPage}?${searchString}`
      : defaultRoutes.allProvidersPage;
    historyPush(path, { casinoPathname: location.pathname, group });
  }, [group, historyPush, location.pathname]);

  if (isEmptyCollection(providers) || categoryGamesLoading) {
    return null;
  }

  return (
    <div className="casino-providers-block">
      <div className="casino-providers-block__header">
        <div className="casino-providers-block__name">
          <div
            className="casino-providers-block__icon"
            style={{
              backgroundImage: `url("${BASE_PATH}/static/assets/icons/icon-settings.png")`,
            }}
          />
          <Label className="casino-providers-block__title" message="providers_title" />
        </div>
        {allProvidersPage.isActive && (
          <ChipsItem
            className="casino-providers-block__view-all"
            label={<Label className="casino-providers-block__view-all-text" message="View_All" />}
            onClick={showAllProvidersHandler}
          />
        )}
      </div>
      <ProvidersBlockSlider onProviderClick={onProviderClick} providers={providers} />
    </div>
  );
};

export default ProvidersFilterBlock;

ProvidersFilterBlock.propTypes = {
  onProviderClick: PropTypes.func,
};
